<div class="product-qa-description-container">
    <div class="product-qa-description-image-container">
      <img [src]="selectedProduct.image_link" alt="product-image" height="54" width="54" class="product-qa-description-image" *ngIf="selectedProduct.image_link !== 'NA~NA'; else defaultImage"/>
    <ng-template #defaultImage>
        <img
            src="../../../assets/default_placeholder.png"
            alt="product-image"
            class="product-qa-description-image"
            height="54" width="54"
            >
    </ng-template>
    </div>
    <div class="product-qa-description">
      <div class="product-qa-description-text">
        {{ selectedProduct.ProductName }}
      </div>
      <div class="product-qa-id">
        ID: {{ selectedProduct.id }}
      </div>
    </div>
  </div>